import { DatePicker, Form, Input, message, Select } from 'antd';
import { useEffect, useMemo, useState, useCallback } from 'react';
import { useFooterButton } from '../../pages/authentication/sign-up/signup-context';
import LilyButton from '../../components/button/lily-button';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { VERIFY_CARD } from '../../api/URLs';
import portalAPI from '../../api/api';
import { parseDob } from '../../exports/util';

const SavingCard = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { patientForm, setPatientForm, setFooterButton, setCurrent, setCurrentProcess, setRegistrationToken } = useFooterButton();
    let initError = {
        email: '',
        firstName: '',
        lastName: '',
        dob: '',
        memberId: '',
    }
    const [errors, setErrors] = useState(initError)

    const handleNext = useCallback(async () => {
        try {
            const values = await form.validateFields(); // Will throw if invalid
            setIsLoading(true);

            let filledData = {
                ...values,
                dob: values.dob ? values.dob.format("MM/DD/YYYY") : ''
            }

            const rspCopay = await portalAPI.post(VERIFY_CARD, filledData);

            let copayData = rspCopay.data;

            let newBody = copayData.patientInfo;
            newBody['email'] = values.email;

            if (copayData && copayData.status === 202) {
                if (copayData.invalidFields.length > 0) {
                    navigate('/auth/undefined');
                    return false;
                }
            } else {
                setErrors(initError)
            }
            setRegistrationToken(copayData.token);
            setPatientForm((prev) => ({
                ...prev,
                ...newBody,
                dob: newBody.dob ? parseDob(newBody.dob) : null
            }))
            setCurrent(1);
        } catch (error) {
            if (error.errorFields) {
                message.warning('Please complete the required fields.');
                return false;
            }
            const status = error?.response?.status;
            const backendMessage = error?.response?.data?.message;
            if (status === 403) {
                navigate('/auth/undefined');
                return false;
            }
            if (backendMessage) {
                message.error(backendMessage);
                return false;
            }
            navigate('/auth/undefined');
        } finally {
            setIsLoading(false);
        }
    }, [form, navigate]);

    useEffect(() => {
        form.setFieldsValue({
            email: patientForm.email || '',
            firstName: patientForm.firstName || '',
            lastName: patientForm.lastName || '',
            dob: patientForm.dob || null,
            memberId: patientForm.memberId || '',
        })
    }, [patientForm]);

    const footerButton = useMemo(() => (
        <div className='d-flex flex-row justify-content-end'>
            <LilyButton
                text="Next"
                style={{ width: '120px' }}
                size="large"
                loading={isLoading}
                onClick={handleNext}
            />
        </div>
    ), [isLoading, handleNext]);

    useEffect(() => {
        setCurrentProcess(0);
        setFooterButton(footerButton);
    }, [footerButton, setCurrentProcess, setFooterButton]);

    return (
        <div>
            <Form
                form={form}
                name="access-card"
                layout="vertical"
            >
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, message: 'Email is required.' }]}
                    validateStatus={errors.email ? 'error' : ''}
                    help={errors.email}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[{ required: true, message: 'First Name is required.' }]}
                    validateStatus={errors.firstName ? 'error' : ''}
                    help={errors.firstName}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[{ required: true, message: 'Last Name is required.' }]}
                    validateStatus={errors.lastName ? 'error' : ''}
                    help={errors.lastName}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Date of Birth"
                    name="dob"
                    rules={[{ required: true, message: 'Date of Birth is required.' }]} className='mb-3'
                    validateStatus={errors.dob ? 'error' : ''}
                    help={errors.dob}
                >
                    <DatePicker className='w-100' format={'MM/DD/YYYY'} />
                </Form.Item>
                <Form.Item
                    label="Copay Card Member ID#"
                    name="memberId"
                    rules={[{ required: true, message: 'Member ID is required.' }]}
                    validateStatus={errors.memberId ? 'error' : ''}
                    help={errors.memberId}
                >
                    <Input />
                </Form.Item>
            </Form>
        </div>
    );
};

export default SavingCard;